var DropDown = require('../../../../../common/dropDown/dropDownContentView');


/**
 * The template is very similar to that in the header overflow menu dropdown --
 * should share code but for now this is simple so just go with it.
 * The same is true for the UI hash and events
 */


module.exports = DropDown.extend({
    template: require('./template.hbs'),
    ui: {
        pdfComboNewWindow:  '#pdfComboLink-nav',
        pdfComboDL:         '#pdfComboDL-nav'
    },
    ddOptions: {
        dropUp: 1
    },
    events: function() {
        var vCh = this.options.vChannel;
        return {
            'click @ui.pdfComboDL':         _.bind(vCh.command, vCh, 'exportAllDocumentsAsPDF', 0), /* put 0 in explicity, otherwise e is passed */
            'click @ui.pdfComboNewWindow':  _.bind(vCh.command, vCh, 'exportAllDocumentsAsPDF', 1)
        };
    },
    getDropdownButton: function() {
        return require('./pdfDropDownButton/bundle');
    }

    //destroy: small mem leak in sub-menu bars ...
    // again, all this complicated by the other plugins and old arch involved --
    // here looks like ref in the jq cache prev obj to 'sub-menu-items*/
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/views/nav/navBar/comboPdf/view.js
 ** module id = 699
 ** module chunks = 0
 **/